'use client';

import { resolveStringArray } from '@macaron-a2ui/core/v0_8';
import { MACARON } from './tokens';
import type { MacaronRenderContext, RecordAny } from '@macaron-a2ui/core/v0_8';

export function MacaronFilterTags({ config, ctx }: { config: RecordAny; ctx: MacaronRenderContext }) {
  const tags = resolveStringArray(config.tags, ctx.data);
  if (tags.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-2">
      {tags.map((tag) => (
        <span key={tag} className="rounded-lg px-2 py-0.5 font-sans text-[14px] font-normal leading-[1.86]" style={{ backgroundColor: MACARON.filterTagBg, color: MACARON.filterTagText }}>
          {tag}
        </span>
      ))}
    </div>
  );
}
